export default __webpack_public_path__ + "static/media/653.fbdd5b51.png";